var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgFormatText = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 20,
  height: 20,
  fill: "none"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#format-text_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M12 16 7 4H5L0 16h2.167l1.25-3h5.166l1.25 3zm-4.042-4.5L6 6.8l-1.958 4.7zM18 14.65c-.635.833-1.52 1.35-2.5 1.35-1.933 0-3.5-2.015-3.5-4.5S13.567 7 15.5 7c.98 0 1.865.517 2.5 1.35V7h2v9h-2zm0-3.15c0 1.657-.895 3-2 3-1.104 0-2-1.343-2-3s.896-3 2-3c1.105 0 2 1.343 2 3",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "format-text_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h20v20H0z"
})))));
export default SvgFormatText;